function ObjectEvent(type) {
    let ret = function (fun) {
        ret.addListener(fun);
    };
    ret.type = type;
    ret._listeners = [];
    ret.addListener = function (fun) {
        ret._listeners.push({fun});
    };
    ret.call = function (target, eventData = {}) {
        let event = new Event(ret.type);
        Object.assign(event, eventData);

        if ((eventData instanceof Event)) {
            event.oryginalEvent = eventData;
        }
        event.target = target;
        for (let listener of ret._listeners) {
            try {
                listener.fun.call(target, event);
            } catch (ex) {
                console.error(ex);
            }
        }
    };
    return ret;
}

module.exports.ObjectEvent = ObjectEvent;